import(/* webpackMode: "eager" */ "/opt/workspace/dapp/src/app/apply/[dappName]/page.tsx")